/* ------------------------- External Dependencies -------------------------- */
import React from 'react';
import { Box } from 'atomic'
export default props => <Box {...props} onClick={props.drawerClose} />



// WEBPACK FOOTER //
// ./src/interface/containers/drawer/DrawerClose/render/index.js